import { computed } from 'vue'
import type { ISteps } from 'refresh-ui'
import { useRoute } from '#imports'

export function useStepNavigation(blocks: ComputedRef<ISteps>) {
  const route = useRoute()

  // Index over *visible* steps only — MultiStepForm renders the visible-filtered
  // array, so a requested `?step=` must map to its position in that same list.
  // A hidden or unknown step falls back to the first step.
  const getStepOrder = (stepName: string): number => {
    const visibleStepNames = Object.entries(blocks.value)
      .filter(([, step]) => step.visible === true)
      .map(([name]) => name)
    return visibleStepNames.indexOf(stepName)
  }

  const initStep = computed(() => {
    const stepParam = String(route.query.step || '')
    const order = getStepOrder(stepParam)
    return order >= 0 ? order : 0
  })

  const debugSteps = computed(() => {
    return Object.values(blocks.value).map(step => ({
      key: step.name,
      title: step.title,
    }))
  })

  const isPreview = computed(() => route.query.preview === 'true')
  const isDebug = computed(() => route.query.debug === 'true' || isPreview.value)

  return {
    initStep,
    debugSteps,
    isDebug,
    isPreview,
  }
}
